export default {
    state: {
        credentials: null,
        saved_discount_code: null,
        discount: null,
        saved_sweepstakes_code: null,
        sweepstakes: null,
        cartData: null,
        quoteData: null,
        lastOrder: null,
    },
    mutations: {
        storeLastOrder (state, payload) {
            state.lastOrder = payload
        },
        storeNewAccountCredentials (state, payload) {
            state.credentials = payload;
        },
        saveDiscountCode (state, payload) {
            state.saved_discount_code = payload;
        },
        addDiscount (state, payload) {
            state.discount = payload;
        },
        setCartData(state, payload) {
            state.cartData = payload;
        },
        setQuote(state, quote) {
            state.quoteData = quote;
        },
        clearQuote(state) {
            state.quoteData = null;
        }
    },
    getters: {
        getRegisteredEmail(state) {
            return state.credentials.email || null;
        }
    },
    actions: {
        saveNewAccountCredentials(context, data) {
            context.commit('storeNewAccountCredentials', data);

            return new Promise((resolve, reject) => {
                this._vm.axios.post('/auth/register', data)
                    .then(resolve)
                    .catch(reject);
            });
        },
        getFrameToken(state, cartData) {
            return new Promise((resolve, reject) => {
                this._vm.axios.post(`/checkout/formToken`, cartData)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch(reject);
            });
        },
        cartCosts(state, cartData) {
            cartData['online_order'] = 1;
            return new Promise((resolve, reject) => {
                this._vm.axios.post("/costs/cart_price", cartData)
                    .then(response => {
                        // Handle Success
                        if (response.data && response.data.success) {
                            resolve(response.data);
                        }
                        // Handle Error
                        reject(response);
                    }).catch(error => {
                    reject(error);
                });
            });
        },
        postOrder(state, orderData) {
            return this._vm.axios.post(`checkout/log`, orderData);
        }
    }

}
